import Model from '../model'
import Enum from '../enums'

export default class ServiceAssociation extends Model {
  static modelName () {
    return 'serviceAssociation'
  }

  /**
   * Formats the discounted list price for an add-on association (fixed or percentage off target price).
   * @param {object|null|undefined} association - `discountAmount`, `discountType`, and `target.price`
   * @param {string} currencySymbol
   * @returns {string} Formatted price, or empty string when there is no applicable discount
   */
  static formatDiscountedPrice (association, currencySymbol) {
    if (!association?.target || Number(association.discountAmount) <= 0) {
      return ''
    }

    const { discountAmount, discountType } = association
    const basePrice = association.target.price

    const format = amount =>
      currencySymbol + parseFloat(amount || 0).toFixed(2)

    if (discountType === ServiceAssociationDiscountType.fixed) {
      return format(basePrice - discountAmount)
    }

    if (discountType === ServiceAssociationDiscountType.percentage) {
      return format(basePrice - (basePrice * discountAmount) / 100)
    }

    return ''
  }

  objectID () {
    return this.idAssociation
  }

  relations () {
    return {
      orderType: { type: ServiceAssociationOrderType },
      discountType: { type: ServiceAssociationDiscountType },
    }
  }
}

export const ServiceAssociationOrderType = new Enum({
  after: { value: 0, description: 'components.service.actions.editAddOn.after' },
  before: { value: 1, description: 'components.service.actions.editAddOn.before' },
})

export const ServiceAssociationDiscountType = new Enum({
  fixed: { value: 0, description: 'general.fixed' },
  percentage: { value: 1, description: 'general.percentage' },
})
